import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import {
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  EnvironmentConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  RestService,
  ServerSettingsService,
  SettingsService,
} from '@infodata-group/inf-commons';
import { infcW3hostnameInterceptor } from '@infodata-group/inf-commons-core';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpInterceptorFn,
} from '@angular/common/http';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { HttpStatusInterceptor } from '../interceptor/http-status.interceptor.interceptor';
import { environment } from '../../environments/environment';

export const commonsProvidersFrom = [EditorModule];

export const commonsInterceptors: HttpInterceptorFn[] = [
  infcW3hostnameInterceptor,
];

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
  { provide: SettingsService, useClass: ServerSettingsService },
  { provide: RestService, useClass: RestService },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpStatusInterceptor,
    multi: true,
  },
  {
    provide: TINYMCE_SCRIPT_SRC,
    useValue: 'https://assets.integrix.lu/tinymce/tinymce.min.js',
  },
];
